import { render, staticRenderFns } from "./aLteAsideUser.vue?vue&type=template&id=09774650"
import script from "./aLteAsideUser.vue?vue&type=script&lang=js"
export * from "./aLteAsideUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dem/Go/src/github.com/demget/quadroclub/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('09774650', component.options)
    } else {
      api.reload('09774650', component.options)
    }
    module.hot.accept("./aLteAsideUser.vue?vue&type=template&id=09774650", function () {
      api.rerender('09774650', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aside/aLteAsideUser.vue"
export default component.exports